import { Link } from "gatsby"
import React, { useContext, useRef } from "react"
import CustomerContext from "../../../context/CustomerProvider"

const Login = () => {
  const value = useContext(CustomerContext)
  const signinCustomer = value?.signinCustomer
  const customerErr = value?.customerErr
  const isFetching = value?.isFetching

  const emailRef = useRef()
  const passRef = useRef()

  function handleLoginSubmit(e) {
    e.preventDefault()
    signinCustomer({
      email: emailRef.current.value,
      password: passRef.current.value,
    })
  }

  return (
    <div
      className="container"
      style={{ marginTop: "5rem", marginBottom: "1rem" }}
    >
      <div className="w-100 m-auto" style={{ maxWidth: 600 }}>
        <div className="card">
          <div class="card-body">
            <h3 className="text-center">Login</h3>

            {customerErr && (
              <div className="alert alert-danger" role="alert">
                {customerErr.map((err, i) => (
                  <span key={i}>{err}</span>
                ))}
              </div>
            )}

            <form onSubmit={handleLoginSubmit}>
              <div className="form-group">
                <label htmlFor="email">Email address</label>
                <input
                  type="email"
                  className="custom-form-control"
                  id="email"
                  required
                  ref={emailRef}
                />
              </div>
              <div className="form-group">
                <label htmlFor="password">Password</label>
                <input
                  type="password"
                  className="custom-form-control"
                  id="password"
                  required
                  ref={passRef}
                />
                <Link to="/" className="text-primary">
                  Forgot Password?
                </Link>
              </div>

              <button
                type="submit"
                className="btn btn-dark btn-block"
                disabled={isFetching}
              >
                {isFetching ? "loading.." : "Login"}
              </button>
              <p className="text-center mt-3 mb-0">
                Not register yet?{" "}
                <Link to="/app/register" className="text-primary">
                  Create an Account
                </Link>
              </p>
            </form>
          </div>
        </div>
      </div>
    </div>
  )
}

export default Login
